import React, { useState, useEffect } from "react";

// Components
import Sidebar from "../../components/Sidebar";
import Main from "./TbSetTransType/Main";
import Form from "./TbSetTransType/Form";

// Utils
import { getData, getAlert, getDataWithComp } from "../../../utils/SamuiUtils";
import { InitialDatatype } from "../../../model/InitialData/InitialDataCreditor";

const TbSetTransType = () => {
  const [mode, setMode] = useState("");
  const [dataMasterList, setDataMasterList] = useState([]);
  //   const [dataAPtype, setDataAPtype] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [formData, setFormData] = useState(InitialDatatype());

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      setMode("S");
      fetchRealtime(); // เรียกใช้งาน fetchRealtime เพื่อโหลดข้อมูลเมื่อ component โหลดครั้งแรก
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const fetchRealtime = async () => {
    try {
      // ดึงข้อมูลจาก Tb_Set_AP ทั้งหมด
      const masterList = await getData("Tb_Set_TransType", "1=1");
      //   const dataAPtype = await getData("Tb_Set_APType", "1=1");
      if (masterList && masterList.length > 0) {
        setDataMasterList(masterList);
      }
      //   if (dataAPtype && dataAPtype.length > 0) {
      //     setDataAPtype(dataAPtype);
      //   }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const onPageInsert = () => {
    setMode("I");
  };

  const onRowSelected = (item) => {
    setMode("U");

    setFormData({
      Trans_TypeID: 0,
      Trans_TypeName: "",
      Trans_Status: "Y",
    });
    setSelectedData(item);
  };

  return (
    <div className="Creditor">
      <div className="wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="container">
            <div className="page-inner">
              <div style={{ display: mode === "S" ? "block" : "none" }}>
                <Main
                  masterList={dataMasterList}
                  name={"ข้อมูลวิธีการขนส่ง"}
                  onPageInsert={() => onPageInsert()}
                  onRowSelected={(item) => onRowSelected(item)}
                />
              </div>
              <div style={{ display: mode !== "S" ? "block" : "none" }}>
                <Form
                  callInitialize={initialize}
                  mode={mode}
                  name={"ข้อมูลวิธีการขนส่ง"}
                  formData={formData}
                  setFormData={setFormData}
                  selectedData={selectedData}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TbSetTransType;
